import type { UserTestDto } from "./user-test.dto";
import type { AnswerQuestionDto } from "./answer-question.dto";
import type { CreateUserTestDto } from "./create-user-test.dto";

import { api } from "../core/api";

export async function createUserTest(
  dto: CreateUserTestDto
): Promise<UserTestDto> {
  const { data } = await api.post("/api/v1/user_tests", { user_test: dto });
  return data.data;
}

export async function getUserTest(id: string): Promise<UserTestDto> {
  const url = new URL(window.location.href);
  const { data } = await api.get(
    `/api/v1/user_tests/${id}?${url.searchParams}`
  );
  return data.data;
}

export async function updateUserTest(
  id: string,
  dto: Partial<Pick<UserTestDto, "time_to_complete_in_minutes" | "finished_at">>
): Promise<UserTestDto> {
  const { data } = await api.patch(`/api/v1/user_tests/${id}`, {
    user_test: dto,
  });
  return data.data;
}

export async function startUserTest(id: string): Promise<Partial<UserTestDto>> {
  const { data } = await api.post(`/api/v1/user_tests/${id}/start_test`);
  return data;
}

export async function joinUserTest(id: string, code: string) {
  await api.post(`/api/v1/user_tests/${id}/attach_user`, {
    user: { join_station_code: code },
  });
}

export async function answerChecklistQuestion(dto: AnswerQuestionDto) {
  await api.post(`/api/v1/user_tests/${dto.test_id}/answer_question`, {
    answer: dto,
  });
}

export async function finishChecklist(id: string) {
  const res = await api.post<UserTestDto>(
    `/api/v1/user_tests/${id}/finish_checklist`
  );
  return res.data;
}

export async function sendChatMessage(id: string, text: string) {
  const res = await api.post(`/api/v1/user_tests/${id}/chat`, { text });
  return res.data;
}

export async function getUnlockedExams(userTestId: string) {
  const res = await api.get(`/api/v1/user_tests/${userTestId}/unlocked_exams`);
  return res.data.message as UnlockedExam[];
}
export interface UnlockedExam {
  id: string;
  title: string;
  content: string;
}
